/*
 * @Author: alex
 * @Date: 2022-05-07 13:53:50
 * @LastEditTime: 2022-05-11 16:00:27
 * @LastEditors: alex
 */
import { registerPlugin } from '@capacitor/core';
const SqlitePlugin = registerPlugin('SqlitePlugin', {
    web: () => import('./web').then(m => new m.SqlitePluginWeb()),
});
export * from './definitions';
export { SqlitePlugin };
//# sourceMappingURL=index.js.map